import { Theme } from '../types';

export const forestTheme: Theme = {
  name: 'forest',
  colors: {
    gray: {
      50: '#f7fdf7',
      100: '#e8f5e8',
      200: '#d1e7dd',
      300: '#a3d2a3',
      400: '#6aa76a',
      500: '#4f7c4f',
      600: '#3d5a3d',
      700: '#2d402d',
      800: '#1e2b1e',
      900: '#0f140f',
    },
    accent: {
      50: '#fefce8',
      100: '#fef9c3',
      200: '#fef08a',
      300: '#fde047',
      400: '#facc15',
      500: '#eab308',
      600: '#ca8a04',
      700: '#a16207',
      800: '#854d0e',
      900: '#713f12',
    },
    semantic: {
      success: '#22c55e',
      successLight: '#dcfce7',
      error: '#ef4444',
      errorLight: '#fee2e2',
      warning: '#f59e0b',
      warningLight: '#fef3c7',
      info: '#3b82f6',
      infoLight: '#dbeafe',
    },
    background: {
      app: '#f7fdf7',
      surface: '#ffffff',
      elevated: '#ffffff',
      navbar: '#ffffff',
      sidebar: '#e8f5e8',
      hover: '#e8f5e8',
      active: '#d1e7dd',
      blueprint: 'linear-gradient(135deg, #f7fdf7 0%, #d1e7dd 100%)',
    },
    text: {
      primary: '#0f140f',
      secondary: '#1e2b1e',
      tertiary: '#2d402d',
      disabled: '#a3d2a3',
      inverse: '#ffffff',
      accent: '#a16207',
      onAccent: '#ffffff',
      muted: '#3d5a3d',
    },
    border: {
      color: '#d1e7dd',
      light: '#e8f5e8',
      medium: '#a3d2a3',
    },
    button: {
      bg: '#f7fdf7',
      bgHover: '#e8f5e8',
      bgActive: '#d1e7dd',
      text: '#2d402d',
      border: '#a3d2a3',
      primary: {
        bg: '#22c55e',
        bgHover: '#16a34a',
        bgActive: '#15803d',
        text: '#ffffff',
      },
      disabled: {
        bg: '#e8f5e8',
        text: '#a3d2a3',
        border: '#d1e7dd',
      },
    },
    input: {
      bg: '#ffffff',
      border: '#a3d2a3',
      borderHover: '#6aa76a',
      borderFocus: '#22c55e',
      text: '#0f140f',
      placeholder: '#a3d2a3',
    },
    toggle: {
      bg: '#a3d2a3',
      bgActive: '#22c55e',
      thumb: '#ffffff',
    },
    executing: '#f59e0b',
    focus: '#22c55e',
    overlay: {
      light: 'rgba(15, 20, 15, 0.1)',
      medium: 'rgba(15, 20, 15, 0.2)',
      heavy: 'rgba(15, 20, 15, 0.3)',
      white: 'rgba(255, 255, 255, 0.1)',
    },
    shadow: {
      medium: 'rgba(34, 197, 94, 0.15)',
    },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    // Legacy spacing
    small: '8px',
    medium: '16px',
    large: '24px',
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      xxxl: '30px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    text: {
      xs: '12px',
      small: '14px',
      medium: '16px',
    },
  },
  borderRadius: {
    sm: '6px',
    md: '10px',
    lg: '16px',
    full: '9999px',
    // Legacy border radius
    small: '3px',
    medium: '8px',
  },
  shadows: {
    xs: '0 1px 2px 0 rgba(34, 197, 94, 0.05)',
    sm: '0 1px 3px 0 rgba(34, 197, 94, 0.08), 0 1px 2px -1px rgba(34, 197, 94, 0.08)',
    md: '0 4px 6px -1px rgba(34, 197, 94, 0.08), 0 2px 4px -2px rgba(34, 197, 94, 0.08)',
    lg: '0 10px 15px -3px rgba(34, 197, 94, 0.08), 0 4px 6px -4px rgba(34, 197, 94, 0.08)',
    xl: '0 20px 25px -5px rgba(34, 197, 94, 0.08), 0 8px 10px -6px rgba(34, 197, 94, 0.08)',
  },
  zIndex: {
    dropdown: 100,
    sticky: 200,
    overlay: 500,
    modal: 1000,
    toast: 2000,
    // Legacy z-index
    base: 0,
    accent: 5,
    content: 10,
    floating: 20,
  },
  transitions: {
    fast: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
    base: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1536px',
  },
};


